import React, {Component} from 'react';
import {Icon, Divider} from 'semantic-ui-react';


class Index extends Component {
  render() {
    return (
      <div className='access-denied'>
        <div className='icon'>
          <Icon.Group size='huge'>
            <Icon loading name='sun' size='big' />
            <Icon name='close' size='small' />
          </Icon.Group>
        </div>
        <Divider />
        <div className='ui huge error message'>
          Usted no tiene permiso para ingresar a esta página.
        </div>
      </div>
    );
  }
}

export default Index;
